import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

export const store = new Vuex.Store({
    state: {
        navList: [
            { title: '首页', name: 'Index' },
            { title: '活动推广营销', name: 'Promote' },
            { title: '微信吸粉传播', name: 'Spread' },
            { title: '解决方案', name: 'Plan' },
            { title: '会员价格', name: 'Price' },
            { title: '联系我们', name: 'Relat' },
        ], //导航数据
        phone: /^1(3|4|5|6|7|8|9)\d{9}$/, // 验证手机号
        email: /^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$/, // 验证邮箱
       
        rules: {
            mobile: [
                { required: true, message: '请输入手机号', trigger: 'change' },
                { min: 11, max: 13, message: '请输入11手机号', trigger: 'blur' }
            ],
            password: [
                { required: true, message: '请输入密码', trigger: 'change' },
                { min: 8, max: 18, message: '长度在 8 到 18 个字符', trigger: 'blur' }
            ],
            code: [
                { required: true, message: '请输入手机验证码', trigger: 'chansge' },
                { min: 6, message: '长度在6位的验证码', trigger: 'blur' }
            ],
            name: [
                { required: true, message: '请输入用户名称', trigger: 'chansge' },
                { min: 6, max: 16, message: '长度在 6 到 16 个字符', trigger: 'blur' }
            ],
            phone: [
                { required: true, message: '请输入手机号', trigger: 'chansge' },
                { min: 11, max: 13, message: '长度在 11 到 13 位座机号', trigger: 'blur' }
            ],
            demand: [
                { required: true, message: '请输入内容', trigger: 'change' },
                { min: 5, max: 100, message: '长度在 5 到 100 个字符', trigger: 'blur' }
            ],
            email: [
                { required: true, message: '请输入邮箱账号', trigger: 'chansge' },
                { min: 7, message: '长度在7位以上的邮箱账号', trigger: 'blur' }
            ],

            user: [
                { required: true, message: '请输入活动名称', trigger: 'chansge' },
                { min: 2, max: 5, message: '长度在 2 到 5 个字符', trigger: 'blur' }
            ],
            type: [
                { type: 'array', required: true, message: '请至少选择一个活动性质', trigger: 'change' }
            ],
            username: [
                { required: true, message: '请输入真实姓名', trigger: 'chansge' },
                { min: 2, max: 8, message: '长度在 2 到 8 个字符', trigger: 'blur' }
            ],
            entername: [
                { required: true, message: '请输入企业名称', trigger: 'chansge' },
                { min: 2, message: '长度至少两位的企业名称', trigger: 'blur' }
            ],
            registrat: [
                { required: true, message: '请输入营业执照注册号', trigger: 'chansge' },
                { min: 1, message: '请填写正确的营业执照注册号', trigger: 'blur' }
            ],
            credit: [
                { required: true, message: '统一社会信用代码', trigger: 'chansge' },
                { min: 1, message: '请填写正确的统一社会信用代码', trigger: 'blur' }
            ],
            address: [
                { required: true, message: '请输入详细地址', trigger: 'change' },
                { min: 5, max: 30, message: '长度在 5 到 30 个字符', trigger: 'blur' }
            ],
            industry: [
                { required: true, message: '请输入涉及行业', trigger: 'change' },
                { min: 2, message: '请输入两位以上的涉及行业名称', trigger: 'blur' }
            ],
            program: [
                { required: true, message: '请输入小程序主题', trigger: 'change' },
                { min: 5, message: '请输入5位以上的小程序主题', trigger: 'blur' }
            ],
            stateTime: [
                { required: true, message: '请选择时间', trigger: 'change' },
                { min: 2, message: '请选择时间', trigger: 'blur' }
            ],
        }, //表单验证

		
    }
})


// WEBPACK FOOTER //
// ./src/store/store.js